module.exports = __webpack_public_path__ + "img/280.a8d33bbd.png";